import { createClient } from "@supabase/supabase-js";

import { env } from "../env";

/**
 * Supabase クライアント。
 *
 * anon key は公開前提の値で、アクセス制御は全て RLS 側が担う。
 * 新しいテーブルを追加したときは RLS の有効化とポリシー作成を忘れないこと
 * (→ docs/architecture/security.md)。
 */
export const supabase = createClient(env.supabaseUrl, env.supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    // マジックリンクは戻り先のURLにトークンを載せて返ってくる。
    // **これを false にすると誰もそれを読まず、押しても入れないまま**になる
    // (→ ADR-0016)。パスキーだけの頃は使う場面が無く落としていた。
    detectSessionInUrl: true,
    // implicit を明示する。pkce は要求した端末に残る控えと突き合わせる方式で、
    // メールのリンクを別のブラウザで開くと成立しない。
    // 復旧手段として使う以上、開く場所を選ばない方を採る。
    flowType: "implicit",
    // パスキーはベータ機能のため明示的な opt-in が必要。
    // 有効にしないと signInWithPasskey / registerPasskey が例外を投げる。
    experimental: { passkey: true },
  },
});
